import { modifiers } from '#components/generics/js/styles.js'
import object from '@mailobj-browser/front/js/utils/object.js'
import listener from '@mailobj-browser/front/js/events/listeners/listener.js'
import one from '@mailobj-browser/front/js/selectors/one.js'
import closest from '@mailobj-browser/front/js/selectors/closest.js'
import { events } from '#utilities/js/lightboxes/lightbox.js'
import passive from '@mailobj-browser/front/js/events/options/passive.js'

const { open } = events
const { parseInt } = Number

const onOpen = object(listener, {
  type: open,
  passive,
  task: (
    opener,
    { detail: modal }
  ) => {
    const mainForm = closest('form', opener)
    const modalForm = one('form', modal)
    const startDay = one(`.${modifiers.new_field_input.new_hidden}[name="new_start__day"]`, mainForm)
    const startTime = one(`.${modifiers.new_field_input.new_hidden}[name="new_start__sec"]`, mainForm)
    const endDay = one(`.${modifiers.new_field_input.new_hidden}[name="new_end__day"]`, mainForm)
    const endTime = one(`.${modifiers.new_field_input.new_hidden}[name="new_end__sec"]`, mainForm)
    const mainAllDay = one(`.${modifiers.new_field_input.new_hidden}[name="new_allday"]`, mainForm)
    const modalDay = one('[type="hidden"][name="day"]', modalForm)
    const modalStart = one('[type="hidden"][name="start"]', modalForm)
    const modalDuration = one('[type="hidden"][name="duration"]', modalForm)
    let duration

    if (modalDay) {
      modalDay.value = startDay.value
    }

    if (modalStart) {
      modalStart.value = startTime.value
    }

    if (mainAllDay && parseInt(mainAllDay.value, 10) === 1) {
      duration = 86400
    } else {
      duration = (parseInt(endDay.value, 10) + parseInt(endTime.value, 10)) - (parseInt(startDay.value, 10) + parseInt(startTime.value, 10))

      if (duration > 86400) {
        duration = 86400
      }
    }

    if (modalDuration) {
      modalDuration.value = duration
    }
  }
})
export default button => {
  onOpen.listen(button)
}
